var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.525 13.0253C1.19167 13.242 0.854 13.2543 0.512 13.0623C0.170667 12.871 0 12.5753 0 12.1753V1.82532C0 1.42532 0.170667 1.12932 0.512 0.937324C0.854 0.745991 1.19167 0.758658 1.525 0.975324L9.675 6.15032C9.975 6.35032 10.125 6.63366 10.125 7.00032C10.125 7.36699 9.975 7.65032 9.675 7.85032L1.525 13.0253Z",
    fill: "#9277FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/resume.8e6474790132f2dccaba6e9bbc3e5fc7.svg";
export { ForwardRef as ReactComponent };